import findMechanism from "../api/findMechanism.js";

async function renderMechanism({
  table,
  row,
  setMechBody,
  isQuickSearch,
  interactiveAdvancedSearch,
  showPopups,
  mechanismUnclicked,
  mechanism_marts_id = null,
  navigateToRecord
}) {
  console.log(row);
  console.log(table);
  let foundMechanism = [];
  foundMechanism = await findMechanism({
    table,
    row,
    isQuickSearch,
    interactiveAdvancedSearch,
    showPopups,
    mechanismUnclicked,
    mechanism_marts_id,
    navigateToRecord
  });
  setMechBody(foundMechanism.mechanismBody);
  document.getElementById("overlap").style.display = "block";
  document.getElementById("mechDiv").style.display = "block";
  const elements = document.querySelectorAll("#body *");
  elements.forEach((element) => {
    element.style.filter = "blur(3px)";
  });
}

export default renderMechanism;
